export const getClientOrganizationByClient = /* GraphQL */ `
  query GetClientOrganizationByClient(
    $clientId: ID
    $organizationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelClientOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getClientOrganizationByClient(
      clientId: $clientId
      organizationId: $organizationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        clientId
      }
      nextToken
    }
  }
`;
export const getOrganization = /* GraphQL */ `
  query GetOrganization($id: ID!) {
    getOrganization(id: $id) {
      id
      name
      description
    }
  }
`;
